import React from 'react';
import { graphql } from 'gatsby';
import LitImage from './images/LitImage';
import LitStructuredText from './generic/LitStructuredText';
const ModularImageBody = ({ data }) => {
  const {
    backgroundColor,
    body,
    featureImageDesktop,
    featureImageMobile,
    secondaryBody,
  } = data;
  return (
    <div className={`modular-image-body-container ${backgroundColor}`}>
      <div className="modular-image-body-inner modular-global-width modular-text-center modular-padding-small">
        <LitImage image={featureImageDesktop} alt="illustrated image" />
        <div className="modular-image-body-content modular-text-center modular-p">
          <LitStructuredText data={body} />
          <LitStructuredText data={secondaryBody} />
        </div>
      </div>
    </div>
  );
};

export default ModularImageBody;
export const fragment = graphql`
  fragment ModularImageBody on DatoCmsImageBodyBlock {
    id
    featureImageDesktop {
      gatsbyImageData
    }
    featureImageMobile {
      gatsbyImageData
    }
    body {
      value
    }
    backgroundColor
    secondaryBody {
      value
    }
    internal {
      type
    }
  }
`;
